import React from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader/index'
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/LocalHospital";
import GridContainer from "components/Grid/GridContainer.jsx";
import TagsInput from "react-tagsinput";
import api from "../../api/Api";
import Permissions from '../../util/globalPermissions';
import SweetAlert from "react-bootstrap-sweetalert";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import Tooltip from "@material-ui/core/Tooltip";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    clinicmaster_id,
    getClinicUserId
} from '../../util/globalHelper';
import CustomInput from "../CustomInput/CustomInput";

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    }
};

class TestMappingEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,//
            element: "",//
            api_status: "",//
            read: false,
            alert: null,
            clickedId: "",
            clinicsData: null,
            clinic_id: null,
            clinicmaster_id: null,
            master_tests: [],
            patientList: null,
            clinicMasterList: null,
            redirect: false,
            redirectOne: false,
            redirectAdd: false,
            loading: true,
            selectedDoctorId: "",
            data: []
        };
        this.handleTags = this.handleTags.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCheck = this.onCheck.bind(this);
        this.addTest = this.addTest.bind(this);
        this.removeTest = this.removeTest.bind(this);
        this.onChangePrice = this.onChangePrice.bind(this)
    }

    handleTags(regularTags) {
    }


    CallReadApi = () => {
        // api.getMasterTests({})
        //     .then(json => {
        //         this.setState({data: json.data.data}, () => {
        //             this.setState({
        //                 data: this.state.data.map(item => {
        //                     // patientList: this.state.data.data.map(item => {
        //                     return {
        //                         "_id": item._id,
        //                         "title": item ? item.name : "-",
        //                         "price": item ? item.regular_price : "",
        //                         "discounted_price": "",
        //                         "active":false
        //                     }
        //                 })
        //             })
        //         })
        //     });
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
            this.setState({clinicMasterList: json.data.data})
        }) : this.setState({clinicMasterList: {}});
    };

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
        if (e.target.name === "clinic_id") {
        }
        if (e.target.name === "clinicmaster_id") {
        }
        var postBody = {
            "clinic_master_id": this.state.clinicmaster_id ? this.state.clinicmaster_id : "",
            "clinic_id": this.state.clinic_id ? this.state.clinic_id : "",
            // "page": 0,
            // "limit": this.state.limit
        };
        if (this.state.clinic_id !== "") {
            api.getMasterTests(postBody).then(json => {
                this.setState({data: json.data.data.data}, () => {
                    this.setState({
                        data: this.state.data.map(item => {
                            // patientList: this.state.data.data.map(item => {
                            return {
                                "_id": item._id,
                                "title": item ? item.name : "-",
                                "price": item ? item.clinic_test && item.clinic_test.total ? item.clinic_test.total : 0 : 0,
                                "discounted_price": item ? item.clinic_test && item.clinic_test.discounted_price ? item.clinic_test.discounted_price : 0 : 0,
                                "active": !!(item && item.clinic_test)
                            }
                        })
                    }, () => {
                        this.setState({
                            master_tests: this.state.data.filter(a => a.active === true).map(item => {
                                return {
                                    "_id": item._id
                                }
                            })
                        })
                    })
                })
            });
        }
    }

    componentDidMount() {
        this.CallReadApi();
        this.setState({clinicmaster_id: clinicmaster_id(), clinic_id: getClinicUserId()})
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        });
    }

    onSave() {
        var data = this.state.data;
        var Mdata = this.state.master_tests;
        var finalArr = [];
        Mdata.forEach(function (o1) {
            if (data.filter(a => a._id === o1._id).length > 0) {
                finalArr.push(data.find(a => a._id === o1._id))
            }
        });
        let postBody = {
            "clinic_master_id": this.state.clinicmaster_id,
            "clinic_id": this.state.clinic_id,
            "master_tests": finalArr.map(item => {
                return {
                    "master_test_id": item._id,
                    "discounted_price": item.discounted_price !== "" ? parseInt(item.discounted_price) : 0,
                    "total": parseInt(item.price)
                }
            })
        };
        if (this.state.clinicmaster_id !== null && this.state.clinic_id !== null && finalArr.length > 0) {
            api.editClinicTestBulk(postBody).then(json => {
                if (json.data.isError === false) {
                    var msgcolor = {message: "Test Mapping Updated Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    window.location.reload()
                } else {
                    var msgcolor = {message: "Something went wrong!", color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                }
            })
        }
    }

    onChangePrice(e, type, price, index) {
        e.preventDefault();
        var array = this.state.data;
        if (type === "D") {
            array[index].discounted_price = parseInt(price);
        } else {
            array[index].price = parseInt(price);
        }
        this.setState({data: array});
    }

    addTest(name) {
        var array = this.state.master_tests;
        let obj = {"_id": name};
        this.setState({master_tests: array.concat(obj)})
    }

    removeByAttr(arr, attr, value) {
        var i = arr.length;
        while (i--) {
            if (arr[i]
                && arr[i].hasOwnProperty(attr)
                && (arguments.length > 2 && arr[i][attr] === value)) {
                arr.splice(i, 1);
            }
        }
        return arr;
    };

    removeTest(name) {
        var array = this.state.master_tests;
        this.setState({master_tests: this.removeByAttr(array, "_id", name)});
    }

    onCheck(e, name, value) {
        e.preventDefault();
        const state = this.state;
        state[name] = value;
        value ? this.addTest(name) : this.removeTest(name);
    }


    render() {
        const {data, clinicMasterList, clinicsData, patientList} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        const {classes} = this.props;
        if (this.state.clinicMasterList)
            return (
                <div>

                    {this.state.alert}

                    <Grid container>
                        <GridItem xs={12} sm={12} md={2}>
                            <Button block color="warning" onClick={() => this.onSave()}>
                                <Icon>add</Icon>
                                <span style={{paddingLeft: 10}}>SAVE</span>
                            </Button>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Test Mapping Edit</h4>
                                                {/*<p className={classes.cardCategoryWhite}>*/}
                                                {/*List of all Tests*/}
                                                {/*</p>*/}
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                    <span>
                                        <GridContainer>
                                    <GridItem xs={12} sm={6} md={6}>
                                     {isClinicMasterOrClinic() === "" ? <FormControl
                                         fullWidth>
                                         <InputLabel
                                             htmlFor="clinicmaster_id">
                                             Clinic Master
                                         </InputLabel>
                                         <Select
                                             value={this.state.clinicmaster_id}
                                             onChange={this.onChangeSelect}
                                             inputProps={{
                                                 name: "clinicmaster_id",
                                                 id: "clinicmaster_id"
                                             }}>
                                             <MenuItem
                                                 disabled>
                                                 Select Clinic
                                             </MenuItem>
                                             {clinicMasterList.map((x) => {
                                                 return <MenuItem
                                                     key={Math.random()}
                                                     style={{height: "1.8em"}}
                                                     value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                             })}
                                         </Select>
                                     </FormControl> : null}
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={6}>
                                        {isClinicMasterOrClinic() === "" && this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                            <FormControl
                                                fullWidth>
                                                <InputLabel
                                                    htmlFor="clinic_id">
                                                    Clinic
                                                </InputLabel>
                                                <Select
                                                    value={this.state.clinic_id}
                                                    onChange={this.onChangeSelect}
                                                    inputProps={{
                                                        name: "clinic_id",
                                                        id: "clinic_id"
                                                    }}
                                                >
                                                    <MenuItem
                                                        disabled
                                                    >
                                                        Select Clinic
                                                    </MenuItem>
                                                    {clinicsData.map((x) => {
                                                        return <MenuItem key={Math.random()}
                                                                         style={{height: "1.8em"}}
                                                                         value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                    })}
                                                </Select>
                                            </FormControl>
                                            : null}
                                    </GridItem></GridContainer>
                                    </span>
                                </CardHeader>
                                <CardBody>
                                    {data ?

                                        <Table className={classes.table} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Test Name</TableCell>
                                                    <TableCell align="right">Price</TableCell>
                                                    <TableCell align="right">Discounted Price</TableCell>
                                                    <TableCell align="right">Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.length > 0 && data.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell component="th" scope="row">
                                                            {row.title}
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <CustomInput key={index}
                                                                // labelText="Price"
                                                                // success={this.state.secondaryNumberState[index] === "success"}
                                                                // error={this.state.secondaryNumberState[index] === "error"}
                                                                         id={"Price" + index}
                                                                         formControlProps={{
                                                                             fullWidth: true,
                                                                             required: true
                                                                         }}
                                                                         inputProps={{
                                                                             onChange: (e) => {
                                                                                 this.onChangePrice(e, "P", e.target.value, index);
                                                                                 this.onCheck(e, data[index]._id, true)
                                                                             },
                                                                             value: row.price
                                                                         }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <CustomInput key={index}
                                                                // labelText="Discounted Price"
                                                                // success={this.state.secondaryNumberState[index] === "success"}
                                                                // error={this.state.secondaryNumberState[index] === "error"}
                                                                         id={"DiscountedPrice" + index}
                                                                         ref={"DiscountedPrice" + index}
                                                                         formControlProps={{
                                                                             fullWidth: true,
                                                                             required: true
                                                                         }}
                                                                         inputProps={{
                                                                             onChange: (e) => {
                                                                                 this.onChangePrice(e, "D", e.target.value, index);
                                                                                 this.onCheck(e, data[index]._id, true)
                                                                             },
                                                                             value: row.discounted_price
                                                                             // ref: "DiscountedPrice" + index
                                                                         }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="right">
                                                            <input type="checkbox"
                                                                   checked={this.state.master_tests.filter(a => a._id == data[index]._id).length > 0}
                                                                   onChange={e => this.onCheck(e, data[index]._id, e.target.checked)}/>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        : null}
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

}

TestMappingEdit.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(sweetAlertStyle)(TestMappingEdit);



// WEBPACK FOOTER //
// ./src/components/Tests/testMappingEdit.jsx